import { COLORS } from '@btime/constants'
import { useAlert } from '@btime/react-messager'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { Text, Title } from '../../../../components/presentation/Text'
import { useImport } from '../_load/ImportLoader'
import Center from '../../../../components/helpers/Center'
import FlexGrid from '../../../../components/structure/FlexGrid'
import IconButton from '../../../../components/actions/IconButton'
import Link from '../../../../packages/kiti/components/actions/Link'
import Panel from '../../../../components/structure/Panel'
import Separator from '../../../../components/helpers/Separator'

const ErrorsPanel = ({ onRestartImporter }) => {
  const { t } = useTranslation('import')
  const [downloaded, setDownloaded] = useState(false)
  const importRecord = useImport()
  const modal = useAlert()

  const handleClearState = () => {
    if (downloaded) {
      onRestartImporter()
    } else {
      const shouldClear = modal.confirm({
        title: t('notDownloadedWarning')
      })
      if (shouldClear) onRestartImporter()
    }
  }

  return (
    <Panel flex={12} noMargin>
      <Center>
        <Title size="h5" color={COLORS.red}>
          {t('importError')}
        </Title>
        <Text align="center" color={COLORS.dark3}>
          {t('whatToDoNow')} <br />
          1. {t('downloadIncorrectData')} <br />
          2. {t('fixDataInNewSheet')} <br />
          3. {t('doNewUpload')} <br />
        </Text>

        <Separator weight={4} />

        <FlexGrid gutter={0.5}>
          <Link href={importRecord.outputDocument?.src} useNewTab>
            <IconButton
              label={t('downloadNewSheet')}
              icon="RiDownloadCloud2Line"
              transparent
              color={COLORS.purple}
              onClick={() => setDownloaded(true)}
            />
          </Link>
          <IconButton label={t('doNewUpload')} icon="BsArrowRepeat" transparent onClick={handleClearState} />
        </FlexGrid>
      </Center>
    </Panel>
  )
}

export default ErrorsPanel
